import { setSpecificMessage, hexadecimal } from "valibot";
setSpecificMessage(
  hexadecimal,
  (issue) => `Hexadécimal invalide: reçu ${issue.received}`,
  "fr"
);